import { render, staticRenderFns } from "./AreaMenuComponent.vue?vue&type=template&id=69a6b334&scoped=true"
import script from "./AreaMenuComponent.vue?vue&type=script&lang=js"
export * from "./AreaMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./AreaMenuComponent.vue?vue&type=style&index=0&id=69a6b334&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a6b334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\pj\\Platform\\xrcNet\\xrcNet_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a6b334')) {
      api.createRecord('69a6b334', component.options)
    } else {
      api.reload('69a6b334', component.options)
    }
    module.hot.accept("./AreaMenuComponent.vue?vue&type=template&id=69a6b334&scoped=true", function () {
      api.rerender('69a6b334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/area/areamenu/AreaMenuComponent.vue"
export default component.exports